export const getDevice = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
};

export const getBrowser = () => {
  const userAgent = navigator.userAgent;
  const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
  const isChrome = /CriOS/.test(userAgent); // Chrome on iOS uses CriOS

  if (isChrome) {
    return "Chrome (iOS)";
  } else if (isSafari) {
    return "Safari";
  } else if (/Chrome/.test(userAgent)) {
    return "Chrome";
  } else if (/Firefox/.test(userAgent)) {
    return "Firefox";
  } else if (/Edg/.test(userAgent)) {
    return "Edge";
  } else if (/OPR|Opera/.test(userAgent)) {
    return "Opera";
  } else if (/MSIE|Trident/.test(userAgent)) {
    return "Internet Explorer";
  }

  return "Unknown";
};
